import React, { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { API } from "../../../../../config/api";
import LoaderHome from "../../../../Loader/LoaderHome"

import swal from "sweetalert";


export default function ModalDebrisIndex({ showModal, setShowModal, selectedTooth, positionTooth, onDataChange, setDebrisPerTooth, visibleOdontogram, setVisibleOdontogram, onSave }) {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pages, setPages] = useState();
    const [ascending] = useState(0);
    const [rows, setRows] = useState(1);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");
    const [msg, setMsg] = useState("");
    const token = localStorage.getItem("token");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);


    const [dataDebrisIndex, setDataDebrisIndex] = useState([]);
    const [selectedDebris, setSelectedDebris] = useState([]);


    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };

    const [getDataDebrisIndex, setGetDataDebrisIndex] = useState([]);


    const GetResponseDataDebrisIndex = async () => {
        try {
            setLoading(true);
            const response = await API.get(`/emr-service/debris-index?page=${page}&limit=${limit}&ascending=${ascending}`, fetchParams);
            if (response?.status === 200) {
                const debrisData = response.data.data;
                setGetDataDebrisIndex(debrisData);
                setLoading(false);

                // Kirim semua data ke parent
                if (onDataChange) {
                    onDataChange(debrisData);
                }
            }
        } catch (error) {
            setLoading(false);
            swal({
                title: 'Failed',
                text: `${error.response?.data?.message || 'Something went wrong'}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    };


    useEffect(() => {
        GetResponseDataDebrisIndex()
    }, [page])


    const handleSelectDebris = (item) => {
        if (!item || !item?.id) return;

        const toothPosition = positionTooth?.[selectedTooth] || null;

        // setSelectedDebris((prev) => {
        //     const exists = prev?.some((d) => d?.id === item?.id);
        //     if (exists) {
        //         return prev?.filter((d) => d?.id !== item?.id);
        //     }
        //     return [...prev, item];
        // });

        setSelectedDebris((prev) => {
            const exists = prev?.some((d) => d?.id === item?.id);
            if (exists) {
                return prev?.filter((d) => d?.id !== item?.id);
            }

            return [
                ...prev,
                {
                    ...item,
                    position: toothPosition, 
                },
            ];
        });
    };


    // const handlePilih = () => {

    //     setDebrisPerTooth((prev) => {
    //         const newState = {
    //             ...prev,
    //             [selectedTooth]: selectedDebris.map((item) => item.id),
    //         };
    //         return newState;
    //     });

    //     setShowModal(false);

    //     setVisibleOdontogram(!visibleOdontogram);

    //     GetResponseDataDebrisIndex()
    // };

    const handlePilih = () => {
        if (onSave) onSave(selectedDebris); 
        setShowModal(false);
    };


    return (
        <>

            {loading && <LoaderHome />}

            {/* Modal tampil ketika polygon diklik */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                <Modal.Header closeButton className="bg-info text-white">
                    <Modal.Title>Debris Index Gigi {selectedTooth}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {getDataDebrisIndex && getDataDebrisIndex.length > 0 ? (
                        getDataDebrisIndex.map((item, index) => (
                            <Button
                                key={index}
                                variant={
                                    Array.isArray(selectedDebris) && selectedDebris?.some((d) => d.id === item.id)
                                        ? "info"
                                        : "outline-info"
                                }
                                size="sm"
                                className="m-1"
                                onClick={() => handleSelectDebris(item)}
                            >
                                {item.display_name}
                            </Button>
                        ))
                    ) : (
                        <p className="text-muted">Tidak ada data Debris Index</p>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" className="btn-sm" onClick={() => setShowModal(false)}>
                        Batal
                    </Button>
                    <Button
                        variant="info"
                        size="sm"
                        onClick={handlePilih}
                        disabled={!Array.isArray(selectedDebris) || selectedDebris.length === 0}
                    >
                        Pilih
                    </Button>

                </Modal.Footer>
            </Modal>

        </>
    )
}